<script setup lang="ts">
import { api } from '@/api';
import { type RoleDto } from '@/api/generator';
import PtwBackButton from '@/components/buttons/PtwBackButton.vue';
import { useVeeForm } from '@/components/forms/useVeeForm';
import BasePage from '@/components/pages/BasePage/BasePage.vue';
import BasePageStatus from '@/components/pages/BasePage/BasePageStatus.vue';
import BasePageTitle from '@/components/pages/BasePage/BasePageTitle.vue';
import { routenames } from '@/router/routenames';
import { useLoading } from '@/utils/useLoading';
import { getTranslatedRoleName } from '@/views/roles/utils.ts';
import { onMounted } from 'vue';
import RoleForm from './components/RoleForm.vue';
import type { RoleDetailsViewProps } from './types';
import { entityNotFoundErrorHandler } from '@/errorHandling';
import { useRouter } from 'vue-router';

const props = defineProps<RoleDetailsViewProps>();
const {
  form: { resetForm, values },
} = useVeeForm<RoleDto>({
  mode: 'details',
});

const router = useRouter();

const { action: loadRole, loading } = useLoading(async () => {
  const { result, success } = await api.rolesApi.getRole(
    {
      id: props.id,
    },
    [entityNotFoundErrorHandler(router)],
  );

  if (success && result) {
    resetForm({ values: result });
  }
}, true);

onMounted(loadRole);
</script>

<template>
  <BasePage :loading="loading">
    <template #title>
      <BasePageTitle
        :subtitle="$t('Role_one')"
        :title="getTranslatedRoleName($t, values)"
        :titleId="values.iuid"
      />
    </template>

    <template #status>
      <BasePageStatus :entity="values" />
    </template>

    <template #actions>
      <PtwBackButton :to="{ name: routenames.roles.overview }" />
    </template>
    <RoleForm />
  </BasePage>
</template>
